import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween";

export class DayjsManager {
  constructor() {
    dayjs.extend(utc);
    dayjs.extend(isBetween);
  }

  getInstance() {
    return dayjs;
  }
}

export const dayjsManager = new DayjsManager();
